import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CustomSelector from '@shared/components/CustomSelector';

/**
 * @typedef {object} FormCustomSelectorOwnProps
 * @property {string} name
 * @property {(selectedValue: string | number) => void} [onChange]
 */

/**
 * @typedef {FormCustomSelectorOwnProps & React.ComponentProps<typeof CustomSelector>} FormCustomSelectorProps
 */

/**
 * @param {FormCustomSelectorProps} props
 */
const FormCustomSelector = props => {
  const { name, onChange, ...otherProps } = props;

  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <CustomSelector
          value={field.value}
          setValue={value => {
            field.onChange(value);
            onChange?.(value);
          }}
          error={!!errors[name]}
          {...otherProps}
        />
      )}
    />
  );
};

export default FormCustomSelector;
